import React from "react";
import { useNavigate } from 'react-router-dom';
import { Finish } from "@resources";

const Congratulations = () => {

    const navigate = useNavigate();

    return (
        <div className="flex flex-col bg-white p-6 w-full rounded-b-lg gap-y-5 min-h-sb pb-12">
            <div className="flex flex-col gap-y-3">
                <Finish className="h-56" />
                <h1 className="text-center font-bold text-3xl">Congratulations</h1>
                <h2 className="text-center font-medium text-3xl">You’re all signed up</h2>
                <span className="text-center text-xl font-medium text-gray-600">Keep an eye out so you can enroll in you first bill when it comes due. In the meantime, manage payors and payment methods under <nobr><b>My Account</b></nobr>.</span>
                <span className="text-center text-xl font-medium text-gray-600">Sunbound will debit your account to pay your membership fee on the <b>5th</b>. </span>
            </div>
            <div className="self-center w-full pt-3 pb-20">
                <button type="button" className="btn btn-primary h-14 text-xl font-semibold rounded-full" onClick={() => navigate(`/`)}>Go to Dashboard</button>
            </div>
        </div>
    );
};

export default Congratulations;
